<p>
  This membership was paid for but is not active yet, because no payment method
  was saved for its future payments.
</p>

<p>
  Saving one will activate it. This opens the membership's setup page in the
  Climber App, signed in as
  {{ membership.owner_first_name }} {{ membership.owner_last_name }}, where a
  card or bank account can be added.
</p>

<div class="alert alert-danger" role="alert" *ngIf="errorMessage">
  {{ errorMessage }}
</div>
